import { render, staticRenderFns } from "./problemFollowRecords.vue?vue&type=template&id=5559a3f2&scoped=true&"
import script from "./problemFollowRecords.vue?vue&type=script&lang=js&"
export * from "./problemFollowRecords.vue?vue&type=script&lang=js&"
import style0 from "./problemFollowRecords.vue?vue&type=style&index=0&id=5559a3f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5559a3f2",
  null
  
)

export default component.exports